import React from 'react';
import { connect } from 'react-redux';
import SignupPage from '../SignupPage';
import {
  submitCreateAccountForm,
  showLogin,
  validate,
  showRequestResetPassword,
} from '../../user';

const mapDispatchToProps = dispatch => ({
  onSubmit: data =>
    dispatch(
      submitCreateAccountForm(data, null, {
        doAddToEmailList: true,
      })
    ),
  clickLogIn: () => dispatch(showLogin('Log In')),
  onClickRequestResetPassword: () =>
    dispatch(showRequestResetPassword('Forgot Password')),
});

const mapStateToProps = ({ routing }) => ({
  routing,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SignupPage);
